import { ReelWin } from "./ReelWin";

import { spinData } from '../../server/getServerResposesFun';

import { RespinIndex } from "../../config/GlobalVariableConfig";

import { casinoEventEmitter } from "../../core/CasinoChannelHandler";


export class Reels extends ReelWin {

    constructor() {
        super();
    }


    public update() {
        this.updateReelWin()
    }


    public setReelRunning(val: boolean) {
        this.running = val;
    }


    private resetReelRunning(spinStype: string) {
        this.running = true;

        if (spinStype === "BASE") {
            console.log("inside resetReelRunning Base")
            RespinIndex.reset();
        }

        console.log("currentRespinIndex", RespinIndex.value, spinStype);
    }


    public async startPlay(spinStype: string): Promise<[number, number, number?]> {

        // if (!spinData.dataFeatched) {
        //     await this.waitForData();
        // }

        // Cleanup any existing listeners for 'betDeclined' before adding a new one
        casinoEventEmitter.removeAllListeners('betDeclined');

        // Create a promise that resolves when 'betDeclined' is emitted
        const betDeclinedPromise = new Promise((resolve) => {
            // 'once' ensures automatic cleanup after the event is handled
            casinoEventEmitter.once('betDeclined', () => resolve('BetDeclined'));
        });


        console.log("startPlay for Freegame", this.running, spinStype, RespinIndex.value, spinData.respins.length);

        if (this.running) {
            return [0, 0];
        }

        // if (spinStype === "BASE") {
        //     this.fetchSpinResponse();  // note: no await here
        // }

        this.winLines = [];

        this.resetReelRunning(spinStype);

        let freeGameTrigger = 0;
        let accumulatedsWinAmount = 0;
        let respinWin: number = 0;


        do {
            console.log("startPlay for Freegame", "inside do-while", RespinIndex.value);

            const respinType = RespinIndex.value === 0 ? "reveal" : spinData.respins[RespinIndex.value].type;
            console.log("respinType", respinType);

            if (respinType === "feature_enter") {

                freeGameTrigger = spinData.respins[RespinIndex.value].freeGameTrigger;
                console.log(`feature_enter triggered: ${freeGameTrigger}`);
                this.running = false;

                const accumulatedsWinAmount = spinData.respins[RespinIndex.value].accumulatedsWinAmount;

                RespinIndex.increase();

                return [freeGameTrigger, accumulatedsWinAmount];

            } else if (respinType === "feature_exit" || respinType === "max_win_reached") {

                freeGameTrigger = -1;
                const totalFeatureWin = spinData.respins[RespinIndex.value].accumulatedsWinAmount || 0;
                console.log(`Feature end triggered: ${freeGameTrigger}`);
                this.running = false;
                RespinIndex.increase();

                if (respinType === "max_win_reached") {
                    // this.resetReelsMaxWin();
                    freeGameTrigger = -2;
                }

                // casinoChannel.publish('showMaxWinDialog');

                return [freeGameTrigger, totalFeatureWin, totalFeatureWin];

            } else if (respinType === "reveal" || respinType === "battleRespin" || respinType === "fs_reveal" || respinType === "fs_battleRespin") {

                const isNewSpin: boolean = (respinType === "reveal" || respinType === "fs_reveal");

                if (isNewSpin) {
                    this.resetReelOverlayContFromToggle();
                }

                if (!isNewSpin) {
                    // reelSpinEmitter.emit('updateMultiplier', spinData.respins[RespinIndex.value - 1].respinMultiplier);
                    // reelSpinEmitter.emit('updateSurgeMeter', spinData.respins[RespinIndex.value - 1].surgeMeter);
                }

                // if (respinType === "reveal") {
                //     reelSpinEmitter.emit('updateMultiplier', 0);
                //     reelSpinEmitter.emit('updateSurgeMeter', 0);
                // }
                // else if (respinType === "fs_reveal") {
                //     reelSpinEmitter.emit('updateSurgeMeter', 0);
                // }


                // Race between the reels and the 'betDeclined' event
                const betPromiseResult = await Promise.race([
                    this.startReels(RespinIndex.value, isNewSpin, spinStype), // Reel logic
                    betDeclinedPromise, // Event bet decline
                ]);


                if (betPromiseResult === 'BetDeclined') {
                    console.log('Bet was declined, breaking out of startPlay.');
                    this.resetReelRunning(spinStype);

                    this.isBetDecline = true;
                    // need to check this ***************
                    // this.reelMove1CompletePromise.then(() => {
                    //     this.resetSymbolPositions();
                    // })

                    return [0, -1];
                }


                await this.animateAllWinningSymbols(RespinIndex.value); // this is just marking the winning symbol, not animating symbols here

                // This func is for line toggle,  --- commented out for some issues
                // if (spinData.respins[RespinIndex.value].winLines) {
                //     this.lineToggle(RespinIndex.value);
                // }

                // if (/*RespinIndex.value > 0 &&*/ spinData.respins[RespinIndex.value].multiplier > 1) {
                //     this.setMultValue(spinData.respins[RespinIndex.value].multiplier);
                // }

                // if (spinData.respins[RespinIndex.value].winAmount >= 10 * betValueGlobal) {
                //     const randomIndex = Math.floor(Math.random() * 2); // 0, 1, or 2
                //     const winVariant = randomIndex == 0 ? `win_2` : `win_3`;       // "win_1", "win_2", or "win_3"
                //     reelSpinEmitter.emit('animateCharacter', winVariant);
                // }

                // await this.lineToggle(RespinIndex.value); // this is actual function that animates symbols


                // reelSpinEmitter.emit('updateMultiplier', spinData.respins[RespinIndex.value].respinMultiplier);
                // reelSpinEmitter.emit('updateSurgeMeter', spinData.respins[RespinIndex.value].surgeMeter);

                // if (spinData.respins[RespinIndex.value].winAmount > 0) {
                //     this.resetNonwinSymbols();
                // }

                if (isNewSpin) {
                    respinWin = 0;
                    // this.setAccWinValue(0);
                }

                respinWin += spinData.respins[RespinIndex.value].winAmount;

                accumulatedsWinAmount = spinData.respins[RespinIndex.value].accumulatedsWinAmount;

                // if (respinWin > 0) {
                //     this.setAccWinValue(respinWin);
                // }

                // Check for fs_battleRespin sequence end in free games
                if ((spinStype === "FREEGAME") &&
                    (respinType === "fs_reveal" || respinType === "fs_battleRespin") &&
                    (spinData.respins[RespinIndex.value + 1]?.type !== "fs_battleRespin") &&
                    (spinData.respins[RespinIndex.value + 1]?.type !== "max_win_reached")
                ) {

                    this.running = false;
                    RespinIndex.increase();

                    return [freeGameTrigger, respinWin, accumulatedsWinAmount];
                }
            }

            RespinIndex.increase();
            console.log(`Respin is done for index ${RespinIndex.value}`);

        } while (RespinIndex.value < spinData.respins.length);

        return [freeGameTrigger, accumulatedsWinAmount];  // Return final result if loop completes without early return
    }

}